import { z } from 'zod';

import { slugSchema, uuidSchema } from './common.js';

const displayNameSchema = z.string().trim().min(2).max(120);
const descriptionSchema = z.string().trim().max(500);

export const createDepartmentSchema = z
  .object({
    slug: slugSchema,
    name: displayNameSchema,
    description: descriptionSchema.optional(),
  })
  .strict();

export const updateDepartmentSchema = z
  .object({
    name: displayNameSchema.optional(),
    description: descriptionSchema.nullable().optional(),
    isActive: z.boolean().optional(),
  })
  .strict()
  .refine((value) => Object.keys(value).length > 0, 'Nothing to update.');

export type CreateDepartmentInput = z.infer<typeof createDepartmentSchema>;
export type UpdateDepartmentInput = z.infer<typeof updateDepartmentSchema>;

export const createJobRoleSchema = z
  .object({
    slug: slugSchema,
    name: displayNameSchema,
    description: descriptionSchema.optional(),
    departmentId: uuidSchema,
  })
  .strict();

export const updateJobRoleSchema = z
  .object({
    name: displayNameSchema.optional(),
    description: descriptionSchema.nullable().optional(),
    departmentId: uuidSchema.nullable().optional(),
    isActive: z.boolean().optional(),
  })
  .strict()
  .refine((value) => Object.keys(value).length > 0, 'Nothing to update.');

export type CreateJobRoleInput = z.infer<typeof createJobRoleSchema>;
export type UpdateJobRoleInput = z.infer<typeof updateJobRoleSchema>;

export const createProjectSchema = z
  .object({
    slug: slugSchema,
    name: displayNameSchema,
    clientName: displayNameSchema.optional(),
    projectManagerId: uuidSchema.nullable().default(null),
    divisionManagerId: uuidSchema.nullable().default(null),
  })
  .strict();

export const updateProjectSchema = z
  .object({
    name: displayNameSchema.optional(),
    clientName: displayNameSchema.nullable().optional(),
    projectManagerId: uuidSchema.nullable().optional(),
    divisionManagerId: uuidSchema.nullable().optional(),
    isActive: z.boolean().optional(),
  })
  .strict()
  .refine((value) => Object.keys(value).length > 0, 'Nothing to update.');

export type CreateProjectInput = z.infer<typeof createProjectSchema>;
export type UpdateProjectInput = z.infer<typeof updateProjectSchema>;
